import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-onboarding-header',
  templateUrl: './onboarding-header.component.html',
  styleUrls: ['./onboarding-header.component.scss'],
})
export class OnboardingHeaderComponent implements OnInit {
  public currentPath: string;

  public classesMasterData: any = ['step'];

  public classesExperiences: any = ['step'];

  public classesSkills: any = ['step'];

  public classesCertifications: any = ['step'];

  public classesLanguages: any = ['step'];

  public classesIban: any = ['step'];

  public classedDocuments: any = ['step'];

  ngOnInit() {
    const pathname: string = window.location.pathname.replace('/onboarding/', '');
    this.currentPath = pathname === '/onboarding' ? 'masterdata' : pathname;

    switch (this.currentPath) {
      case 'masterdata':
        this.classesMasterData.push('active');
        break;
      case 'education':
        this.classesMasterData.push('done');
        this.classesCertifications.push('active');
        break;
      case 'experiences':
        this.classesMasterData.push('done');
        this.classesCertifications.push('done');
        this.classesExperiences.push('active');
        break;
      case 'skills':
        this.classesMasterData.push('done');
        this.classesExperiences.push('done');
        this.classesCertifications.push('done');
        this.classesSkills.push('active');
        break;
      case 'languages':
        this.classesMasterData.push('done');
        this.classesExperiences.push('done');
        this.classesSkills.push('done');
        this.classesCertifications.push('done');
        this.classesLanguages.push('active');
        break;
      case 'iban':
        this.classesMasterData.push('done');
        this.classesExperiences.push('done');
        this.classesSkills.push('done');
        this.classesCertifications.push('done');
        this.classesLanguages.push('done');
        this.classesIban.push('active');
        break;
      case 'documents':
        this.classesMasterData.push('done');
        this.classesExperiences.push('done');
        this.classesSkills.push('done');
        this.classesCertifications.push('done');
        this.classesLanguages.push('done');
        this.classesIban.push('done');
        this.classedDocuments.push('active');
        break;
    }

    this.classesMasterData = this.classesMasterData.join(' ');
    this.classesExperiences = this.classesExperiences.join(' ');
    this.classesSkills = this.classesSkills.join(' ');
    this.classesCertifications = this.classesCertifications.join(' ');
    this.classesLanguages = this.classesLanguages.join(' ');
    this.classesIban = this.classesIban.join(' ');
    this.classedDocuments = this.classedDocuments.join(' ');
  }
}
